<script>
import { componentStore } from "@common/componentStore/componentStore";

const editorSettings = {};

const componentWithActionsConfig = {
    cId: "componentWithActions",
    cType: "componentWithActions",
    cTitle: "Component With Error",
    cTemplate: `<div>
        {{computedWithError}}
        <control name="TEST_BUTTON"></control>
    </div>`,
    controls: [
        {
            name: 'TEST_BUTTON',
            type: 'button',
            label: 'Click',
        },
    ]
};

const componentWithActionsCmp = {
    name: "componentWithActions",
    editorSettings: editorSettings,
    props: {},
    data() {
        return {};
    },
    computed: {
        computedWithError() {
            d();
        }
    },
    methods: {
        onLoad() {
            if (this.config) {
                this.config.showComponentActions = true;
            }
        }
    },
    components: {}
};
componentStore.initComponent(componentWithActionsCmp, componentWithActionsConfig);

export { componentWithActionsConfig, componentWithActionsCmp };
export default componentWithActionsCmp;
</script>
